import React from 'react';
import { TemplateLoadingCard } from '@wix/wix-studio-marketplace-lib';
import _ from 'lodash';
import TemplateCardListItemsLoadingState from '@components/Templates/TemplateGallery/TemplateCardListItems/TemplateCardListItemsLoadingState';

interface TemplatesLoadingStateProps {
  isMobileView: boolean;
}

const TemplatesLoadingState: React.FC<TemplatesLoadingStateProps> = ({
  isMobileView,
}) => {
  if (isMobileView) {
    return <TemplateCardListItemsLoadingState isMobileView={true} />;
  }

  return (
    <>
      {_.times(12, (index) => (
        <ul key={index}>
          <TemplateLoadingCard />
        </ul>
      ))}
    </>
  );
};

export default TemplatesLoadingState;
